import { render, staticRenderFns } from "./BoxEditionCard.vue?vue&type=template&id=369d5d6b&"
import script from "./BoxEditionCard.vue?vue&type=script&lang=js&"
export * from "./BoxEditionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports